<template>
  <table class="table table-sm table-responsive-md">
    <thead>
    <tr>
      <th v-if="displayDeviceColumn">{{$t('views.excmcase.form.idDevice')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.date')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.time')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.totalCounter')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.monoCounter')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.colorCounter')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.copy')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.printout')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.a3')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.a4')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.monoA3')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.monoA4')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.colorA3')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.colorA4')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.bkToner')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.cToner')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.mToner')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.yToner')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.message')}}</th>
      <th>{{$t('views.excmdevicestate.list.table.notes')}}</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="i in items" :key="i['@id']">
      <td v-if="displayDeviceColumn">
        <router-link
          v-if="ableToViewDevice"
          :to="{name: 'EXCMDeviceShow', params: {id: i.idDevice['@id']}}">
          {{ i.idDevice.idDeviceModel.idDeviceBrand.brandTitle + ' ' + i.idDevice.idDeviceModel.model + ' - ' + i.idDevice.serialNumber }}
        </router-link>
        <span v-else>{{ i.idDevice.idDeviceModel.idDeviceBrand.brandTitle + ' ' + i.idDevice.idDeviceModel.model + ' - ' + i.idDevice.serialNumber }}</span>
      </td>
      <td>{{ $moment(i.readDate).format('YYYY-MM-DD') }}</td>
      <td>{{ $moment(i.readDate).format('HH:mm') }}</td>
      <td>{{i.counterPrint}}</td>
      <td>{{i.counterMono}}</td>
      <td>{{i.counterColor}}</td>
      <td>{{i.counterCopy}}</td>
      <td>{{i.counterPrint}}</td>
      <td>{{i.counterA3}}</td>
      <td>{{i.counterA4}}</td>
      <td>{{i.counterA3Mono}}</td>
      <td>{{i.counterA4Mono}}</td>
      <td>{{i.counterA3Color}}</td>
      <td>{{i.counterA4Color}}</td>
      <td class="text-center">
        <b-badge>{{i.tonerLevelBk}} %</b-badge>
        <b-progress>
          <b-progress-bar :value="i.tonerLevelBk" variant="primary"></b-progress-bar>
        </b-progress>
      </td>
      <td class="text-center">
        <b-badge>{{i.tonerLevelC}} %</b-badge>
        <b-progress>
          <b-progress-bar :value="i.tonerLevelC" variant="primary"></b-progress-bar>
        </b-progress>
      </td>
      <td class="text-center">
        <b-badge>{{i.tonerLevelM}} %</b-badge>
        <b-progress>
          <b-progress-bar :value="i.tonerLevelM" variant="primary"></b-progress-bar>
        </b-progress>
      </td>
      <td class="text-center">
        <b-badge>{{i.tonerLevelY}} %</b-badge>
        <b-progress>
          <b-progress-bar :value="i.tonerLevelY" variant="primary"></b-progress-bar>
        </b-progress>
      </td>
      <td>{{i.maintenanceStatus}}</td>
      <td>{{i.notes}}</td>
    </tr>
    </tbody>
  </table>
</template>
<script>
import { checkPermission } from '@/utils/checkRoles'

export default {
  name: 'EXCMDeviceStatesTable',
  props: {
    items: {},
    displayDeviceColumn: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ableToViewDevice () {
      return checkPermission('devices', 'EXCMDeviceShow')
    }
  }
}
</script>
